const PROJECTS = [
  {
    tag: "Residential Property",
    title: "Front Garden Renewal, Greater LA",
    img: "/images/photo_5.jpg",
    alt: "Residential front garden with fresh planting beds by Sahagun Landscape",
  },
  {
    tag: "Commercial Property",
    title: "Healthcare Campus Grounds Care",
    img: "/images/photo_3.jpg",
    alt: "Fresh green lawn at a commercial healthcare campus entrance maintained by Sahagun Landscape",
  },
  {
    tag: "Our Crew At Work",
    title: "Commercial Grounds Cleanup",
    img: "/images/photo_6.jpg",
    alt: "Sahagun Landscape crew trimming shrubs and cleaning beds at a commercial building",
  },
  {
    tag: "Irrigation",
    title: "Valve & Line Repair",
    img: "/images/photo_7.jpg",
    alt: "Sahagun Landscape technician repairing an irrigation valve in a commercial planter",
  },
];

export const Work = () => (
  <section id="work" data-testid="work-section" className="py-24 md:py-32 bg-[#2d4a22] text-[#faf8f5]">
    <div className="max-w-6xl mx-auto px-6">
      <div className="max-w-2xl mb-16 reveal">
        <span className="font-mono-type text-xs uppercase tracking-[0.18em] text-[#a4d19b] font-semibold block mb-2">
          Portfolio of Completed Work
        </span>
        <h2 className="font-display text-3xl md:text-5xl uppercase text-[#faf8f5]">
          Real Projects in Los Angeles County
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        {PROJECTS.map((p, i) => (
          <figure
            key={p.title}
            className={`reveal reveal-d${i + 1} img-zoom relative aspect-[4/3] bg-[#22381a] overflow-hidden border border-[#faf8f5]/15 flex flex-col justify-end`}
            data-testid={`project-${i + 1}`}
          >
            <img src={p.img} alt={p.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1f281e]/85 via-transparent to-transparent" />
            <div className="relative p-6">
              <span className="font-mono-type text-xs text-[#a4d19b] uppercase block mb-1">{p.tag}</span>
              <figcaption className="text-base font-bold text-[#faf8f5]">{p.title}</figcaption>
            </div>
          </figure>
        ))}
      </div>

      <div className="reveal p-8 border border-[#faf8f5]/20 bg-[#22381a]/60" data-testid="project-log">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2.5 h-2.5 bg-[#4ade80] rounded-full organic-grow" />
          <h3 className="text-sm font-bold uppercase tracking-wider text-[#faf8f5]">Verified Project Log</h3>
        </div>
        <p className="text-xs text-[#d3e4d0] leading-relaxed">
          Direct client testimonials and photographic case studies from our Paramount and Southern California
          installations will be published here upon completion of our current seasonal cycle.
        </p>
      </div>
    </div>
  </section>
);
